/**
 * Full person name: display name plus last name when the display name only
 * holds the first name. Case- and accent-insensitive containment check.
 */
const fold = (s: string): string => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export function composeExpertName(
  displayName?: string | null,
  lastname?: string | null,
  name?: string | null,
): string {
  const dn = (displayName ?? '').trim();
  const ln = (lastname ?? '').trim();
  if (dn) return ln && !fold(dn).includes(fold(ln)) ? `${dn} ${ln}` : dn;
  return `${(name ?? '').trim()} ${ln}`.trim();
}
